export default "/img/KW.4d87ac32f4ea87b10961eacb5138b788.png";